<div class="modal-wrapper">

    <div class="instruction" *ngFor="let instruction of instructions">
        <mat-checkbox class="box"  (click)="addInstruction(instruction)" >
            {{instruction.name}}
        </mat-checkbox>
    </div>
</div>
